import { render, staticRenderFns } from "./NewFlow.vue?vue&type=template&id=dbd640c6&scoped=true&"
import script from "./NewFlow.vue?vue&type=script&lang=js&"
export * from "./NewFlow.vue?vue&type=script&lang=js&"
import style0 from "./NewFlow.vue?vue&type=style&index=0&id=dbd640c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd640c6",
  null
  
)

export default component.exports